import { useMemo, useState } from 'react';

import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { orderBy } from 'lodash';

import ExpandableSection from '@components/ExpandableSection/ExpandableSection';
import { Requisition } from '@customTypes/requisition';

import PatientDetailOrder from './PatientDetailOrder/PatientDetailOrder';
import OrderInfoDialog from './OrderInfoDialog';

import './PatientDetailOrders.scss';

interface PatientDetailOrdersProps {
  requisitions: Requisition[];
}

export const PatientDetailOrders: React.FC<PatientDetailOrdersProps> = ({ requisitions }) => {
  const [showInfoDialog, setShowInfoDialog] = useState(false);
  const sortedRequisitions = useMemo(() => orderBy(requisitions, ['submitted_at'], ['desc']), [requisitions]);

  return (
    <>
      <ExpandableSection
        id='orders'
        expandableContentId='ordersContent'
        headerTitle={
          <>
            <span>Orders ({sortedRequisitions.length})</span>
            <Button
              size='sm'
              variant='ghost'
              className='ms-1'
              onClick={() => setShowInfoDialog(true)}
              aria-label='Patient Detail Order Info Button'
            >
              <FontAwesomeIcon icon={faCircleInfo} fontSize={16} />
            </Button>
          </>
        }
      >
        {sortedRequisitions.map(requisition => (
          <PatientDetailOrder key={requisition.requisition_id} requisition={requisition} />
        ))}
      </ExpandableSection>

      {showInfoDialog && <OrderInfoDialog onClose={() => setShowInfoDialog(false)} />}
    </>
  );
};
